import { DateInputProps, DateInput as MTDateInput } from '@mantine/dates';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
const dateParser = (date: string) => dayjs(date, 'DD-MM-YYYY').toDate();

// NOTE: Lord knows why but I can't get the mantine DatesProvider to apply a locale to the date input
export const DateInput = (props: DateInputProps) => {
	return (
		<MTDateInput
			valueFormat="DD-MM-YYYY"
			placeholder="DD-MM-YYYY"
			dateParser={dateParser}
			{...props}
		/>
	);
};
